<template>
  <div class="main-width mt-4">
    <VBreadcrumb
      :options="[{ label: '首页', to: '/' }, { label: '帮助中心' }]"
    ></VBreadcrumb>
    <div class="page">
      <div class="page_help">
        <div class="page_title">帮助中心</div>
        <div class="page_help_content">
          <div class="page_help_content_tabs" v-if="helpList">
            <div v-for="tab in helpList" :key="tab.id" class="page_help_content_tab" :class="{'page_help_content_active':tabId === tab.id}" @click="onClick(tab.id)">
              {{ tab.classify }}
            </div>
          </div>
          <nuxt-child />
        </div>
      </div>
      <help-info v-if="serviceInfo" :serviceInfo="serviceInfo"/>
    </div>
  </div>
</template>
<script>
import { computed, ref, useFetch, useRoute, useRouter, useStore, onMounted } from "@nuxtjs/composition-api";
import VBreadcrumb from "@/components/VBreadcrumb.vue";
import HelpInfo from "./helpcenter/help-info.vue";

export default {
  name: "help-center",
  layout: "Main",
  head: { title: "帮助中心" },
  auth: false,
  components: { VBreadcrumb, HelpInfo },

  setup() {
    const router = useRouter()
    const route = useRoute()
    const store = useStore()
    const tabId = ref(null)
    const serviceInfo = computed(() => {
      return store.state.helpCenter.serviceInfo
    })
    const helpList = computed(() => {
      return store.state.helpCenter.helpList
    })
    const onClick = (id) => {
      router.replace({path:'/helpcenter',query:{id: id}})
      tabId.value = id
    }
    onMounted(async () => {
      await store.dispatch("helpCenter/getHelpCenter")
      window.scrollTo(0, 0)
    })
    useFetch(async () => {
      await store.dispatch("helpCenter/getHelpCenter")
      tabId.value = route.value.query.id || store.state.helpCenter.helpList[0].id
    });
    return { tabId,  serviceInfo, helpList, onClick };
  },
};
</script>
<style lang="scss" scoped>
.page {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  margin-top: 22px;
  margin-bottom: 22px;
  min-height: 865px;
}
.page_title {
  border-bottom-width: 1px;
  font-weight: 500;
  height: 65px;
  font-size: 1.25rem;
  line-height: 1.75rem;
  line-height: 65px;
  padding-left: 20px;
  --tw-text-opacity: 1;
  color: rgba(31, 33, 41, var(--tw-text-opacity));
  width: 100%;
}
.page_help {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.25rem;
  margin-right: 10px;
  min-height: 865px;
  width: 948px;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
}
.page_help_content {
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
  min-height: 800px;
}
.page_help_content_tabs {
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 25px;
  width: 155px;
  background: rgba(0, 94, 220, 0.06);
}
.page_help_content_tab {
  border-radius: 0.25rem;
  cursor: pointer;
  height: 40px;
  margin-bottom: 0.5rem;
  padding-left: 14px;
  padding-right: 14px;
  padding-top: 8px;
  padding-bottom: 8px;
  --tw-text-opacity: 1;
  color: rgba(31, 33, 41, var(--tw-text-opacity));
  width: 135px;
}
.page_help_content_active {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
</style>
